const ControladorPaginas = (props) => {
  const qntPaginas = props.eventosFiltrado.length / props.qntPorPagina
  const divRolagem = document.getElementById('conteudo')

  return(
    <div className='flex text-xl gap-2 py-10 items-center'>
      <button className="cursor-pointer py-1 px-3 rounded-xl bg-blue-700 text-slate-50 font-semibold" onClick={() => {
        if(props.paginaAtual > 1){
          props.setPaginaAtual(props.paginaAtual - 1)
          if(divRolagem){divRolagem.scrollTo({ top: 0, behavior: 'smooth' })}
        }
      }}>Anterior</button>

      <div>{props.paginaAtual} de {qntPaginas > parseInt(qntPaginas) ? parseInt(qntPaginas) + 1 : qntPaginas}</div>
      
      <button className="cursor-pointer py-1 px-3 rounded-xl bg-blue-700 text-slate-50 font-semibold" onClick={() => {
        if(props.paginaAtual < qntPaginas){
          props.setPaginaAtual(props.paginaAtual + 1)
          if(divRolagem){divRolagem.scrollTo({ top: 0, behavior: 'smooth' })}
        }
      }}>Proxima</button>
    </div>
  )
}

export default ControladorPaginas